// extracted by mini-css-extract-plugin
module.exports = {"error":"PluginDetail_error__ZOx2Z","button":"PluginDetail_button__AeS1i"};